import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const SectionTitle = styled.h2`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 20px;
  color: ${barnesTheme.colors.primary};
  margin: 0;
  text-transform: none;
  letter-spacing: 0.5px;

  @media print {
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 20px !important;
    color: ${barnesTheme.colors.primary} !important;
    text-transform: none !important;
    letter-spacing: 0.5px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const RedAccentBar = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};
  margin-top: 8px;

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    margin-top: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SectionSubtitle = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.medium};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.medium} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
